// src/Component/chat/component/index.tsx - UPDATED VERSION
import { Drawer } from "flowbite-react";
import { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import ChatListing from "./ChatListing";
import ChatContent from "./ChatContent";
import CardBox from "./CardBox";
import useCustomScrollbar from "../../styles/useCustomScrollbar";
import { ChatContext } from "../../../context/ChatContext/chatContext";
// ❌ Remove ChatProvider import - it's now in Layout.tsx

const ChatsApp = () => {
  useCustomScrollbar();
  const [isOpenChat, setIsOpenChat] = useState(false);
  const handleClose = () => setIsOpenChat(false);
  const location = useLocation();
  const { isChatDataLoaded, selectChatByUserId } = useContext(ChatContext);

  // Auto-select a specific user's chat when navigated from the Sales drawer
  useEffect(() => {
    const userId = (location.state as { openChatForUserId?: string } | null)?.openChatForUserId;
    if (!userId || !isChatDataLoaded) return;
    selectChatByUserId(String(userId));
    // Clear the state so navigating back and forth doesn't re-trigger
    window.history.replaceState({}, '');
  }, [isChatDataLoaded, location.state, selectChatByUserId]);

  return (
    // ❌ Remove ChatProvider wrapper - context is now at Layout level
    <CardBox className="mx-[32px] my-[4px] overflow-hidden h-[calc(100vh-6rem)]">
      <div className="flex h-full">
        {/* Left Side - Chat List */}
        <div className="lg:w-[350px] lg:flex-shrink-0 lg:flex hidden border-r border-ld h-full">
          <ChatListing />
        </div>

        {/* Mobile Drawer for Chat List */}
        <Drawer
          open={isOpenChat}
          onClose={handleClose}
          className="lg:hidden max-w-[350px] w-full"
        >
          <ChatListing />
        </Drawer>

        {/* Right Side - ChatContent handles everything */}
        <div className="flex-1 flex flex-col h-full min-w-0">
          <ChatContent onClickMobile={() => setIsOpenChat(true)} />
        </div>
      </div>
    </CardBox>
  );
};

export default ChatsApp;